"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  margin: 0 auto;\n  padding-left: ", "px;\n  padding-right: ", "px;\n  width: 100%;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Container = _styledComponents.default.div(_templateObject(), function (props) {
  return props.theme.spacing.unit;
}, function (props) {
  return props.theme.spacing.unit;
}, function (props) {
  var _ref;

  return _ref = {}, _defineProperty(_ref, props.theme.breakpoints.up('sm'), {
    width: "".concat(props.theme.breakpoints.values.sm, "px")
  }), _defineProperty(_ref, props.theme.breakpoints.up('md'), {
    width: "".concat(props.theme.breakpoints.values.md, "px")
  }), _defineProperty(_ref, props.theme.breakpoints.up('lg'), {
    width: "".concat(props.theme.breakpoints.values.lg, "px")
  }), _ref;
});
/** @component */


var _default = Container;
exports.default = _default;